import React, { createContext, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "tracesync-selected-plant";
const PlantSelectionContext = createContext(null);

export const PlantSelectionProvider = ({ children }) => {
  const [selectedPlantId, setSelectedPlantIdState] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) || ""
  );

  const setSelectedPlantId = (value) => {
    const nextValue = value ? String(value) : "";
    setSelectedPlantIdState(nextValue);
    if (nextValue) sessionStorage.setItem(STORAGE_KEY, nextValue);
    else sessionStorage.removeItem(STORAGE_KEY);
  };

  const value = useMemo(
    () => ({ selectedPlantId, setSelectedPlantId }),
    [selectedPlantId]
  );

  return (
    <PlantSelectionContext.Provider value={value}>
      {children}
    </PlantSelectionContext.Provider>
  );
};

export const usePlantSelection = () => {
  const context = useContext(PlantSelectionContext);
  if (!context) throw new Error("usePlantSelection must be used within PlantSelectionProvider");
  return context;
};
